module.exports = __webpack_public_path__ + "static/media/add_licenses.2dd8b958.png";